var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "homeWrapper" }, [
    _c("h1", { staticStyle: { "font-weight": "bolder" } }, [
      _vm._v(_vm._s(_vm.dashText.welcome))
    ]),
    _vm._v(" "),
    _c(
      "h5",
      { staticStyle: { "font-size": "15px", "margin-bottom": "30px" } },
      [_vm._v(_vm._s(_vm.timestampData))]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        class: {
          tableToggleOpen: _vm.checkToggle,
          tableTogglClose: !_vm.checkToggle
        }
      },
      [
        _c(
          "div",
          [
            _c(
              "div",
              {
                staticStyle: {
                  padding: "0 11px 0 11px",
                  top: "0",
                  right: "0",
                  left: "300px",
                  background: "#323b46",
                  "min-height": "56px",
                  height: "56px",
                  display: "flex"
                }
              },
              [
                _c("div", {
                  staticStyle: { flex: "0 0 40%", "padding-right": "12px" }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { flex: "0 0 30%", padding: "14px 0 0 0" } },
                  [
                    _c(
                      "ul",
                      {
                        staticStyle: {
                          "list-style": "none",
                          "padding-left": "0",
                          display: "flex",
                          "justify-content": "flex-start"
                        }
                      },
                      [
                        _c(
                          "li",
                          {
                            staticStyle: {
                              margin: "0 10px 0 0",
                              display: "inline",
                              color: "#fff"
                            },
                            attrs: { title: "Duration" }
                          },
                          [
                            _c(
                              "i",
                              {
                                staticClass: "material-icons",
                                staticStyle: {
                                  position: "relative",
                                  top: "5px"
                                }
                              },
                              [_vm._v("")]
                            ),
                            _vm._v(" "),
                            _c("span", [
                              _c("span", {}, [
                                _vm._v(_vm._s(_vm.reportTotDuration))
                              ])
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            staticStyle: {
                              margin: "0 0 0 10px",
                              display: "inline",
                              color: "#fff"
                            },
                            attrs: { title: "Tests" }
                          },
                          [
                            _c(
                              "i",
                              {
                                staticClass: "material-icons",
                                staticStyle: {
                                  position: "relative",
                                  top: "5px"
                                }
                              },
                              [_vm._v("")]
                            ),
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.reportTotTests) +
                                "\n            "
                            )
                          ]
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { flex: "0 0 20%", "padding-top": "14px" } },
                  [
                    _c(
                      "ul",
                      {
                        staticStyle: {
                          "list-style": "none",
                          "padding-left": "0",
                          display: "flex",
                          "justify-content": "space-evenly"
                        }
                      },
                      [
                        _c(
                          "li",
                          {
                            staticStyle: {
                              display: "inline",
                              color: "#fff",
                              flex: "0 0 25%"
                            },
                            attrs: { title: "Passed" }
                          },
                          [
                            _c(
                              "i",
                              {
                                staticClass: "material-icons",
                                staticStyle: {
                                  position: "relative",
                                  top: "5px",
                                  color: "#388e3c",
                                  "background-color": "#c8e6c9",
                                  "border-radius": "50%"
                                }
                              },
                              [_vm._v("")]
                            ),
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.reportTotPassed) +
                                "\n            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            staticStyle: {
                              display: "inline",
                              color: "#fff",
                              flex: "0 0 25%"
                            },
                            attrs: { title: "Failed" }
                          },
                          [
                            _c(
                              "i",
                              {
                                staticClass: "material-icons",
                                staticStyle: {
                                  position: "relative",
                                  top: "5px",
                                  color: "#d32f2f",
                                  "background-color": "#ffcdd2",
                                  "border-radius": "50%"
                                }
                              },
                              [_vm._v("")]
                            ),
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.reportTotFailed) +
                                "\n            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            staticStyle: {
                              display: "inline",
                              color: "#fff",
                              flex: "0 0 25%"
                            },
                            attrs: { title: "Pending" }
                          },
                          [
                            _c(
                              "i",
                              {
                                staticClass: "material-icons",
                                staticStyle: {
                                  position: "relative",
                                  top: "5px",
                                  color: "#616161",
                                  "background-color": "#f5f5f5",
                                  "border-radius": "50%"
                                }
                              },
                              [_vm._v("")]
                            ),
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.reportTotPending) +
                                "\n            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            staticStyle: {
                              display: "inline",
                              color: "#fff",
                              flex: "0 0 25%"
                            },
                            attrs: { title: "Skipped" }
                          },
                          [
                            _c(
                              "i",
                              {
                                staticClass: "material-icons",
                                staticStyle: {
                                  position: "relative",
                                  top: "5px",
                                  color: "#0288d1",
                                  "background-color": "#b3e5fc",
                                  "border-radius": "50%"
                                }
                              },
                              [_vm._v("")]
                            ),
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.reportTotSkipped) +
                                "\n            "
                            )
                          ]
                        )
                      ]
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _vm._l(_vm.reportSuites, function(rootSuite) {
              return _c(
                "section",
                {
                  key: rootSuite.uuid,
                  staticStyle: {
                    border: "1px solid #e0e0e0",
                    padding: "10px",
                    "margin-bottom": "10px"
                  }
                },
                [
                  _c("header", [
                    _c("div", { staticStyle: { display: "flex" } }, [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            flex: "0 0 70%",
                            "padding-top": "20px"
                          }
                        },
                        [_c("h3", [_vm._v(_vm._s(rootSuite.title))])]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            flex: "0 0 20%",
                            "padding-top": "20px"
                          }
                        },
                        [
                          _c(
                            "ul",
                            {
                              staticStyle: {
                                "list-style": "none",
                                "padding-left": "0",
                                display: "flex",
                                "justify-content": "space-evenly"
                              }
                            },
                            [
                              _c(
                                "li",
                                {
                                  staticStyle: {
                                    display: "inline",
                                    color: "#000000",
                                    flex: "0 0 25%"
                                  },
                                  attrs: { title: "Passed" }
                                },
                                [
                                  _c(
                                    "i",
                                    {
                                      staticClass: "material-icons",
                                      staticStyle: {
                                        position: "relative",
                                        top: "5px",
                                        color: "#388e3c",
                                        "background-color": "#c8e6c9",
                                        "border-radius": "50%"
                                      }
                                    },
                                    [_vm._v("")]
                                  ),
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(rootSuite.passes) +
                                      "\n                "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "li",
                                {
                                  staticStyle: {
                                    display: "inline",
                                    color: "#000000",
                                    flex: "0 0 25%"
                                  },
                                  attrs: { title: "Failed" }
                                },
                                [
                                  _c(
                                    "i",
                                    {
                                      staticClass: "material-icons",
                                      staticStyle: {
                                        position: "relative",
                                        top: "5px",
                                        color: "#d32f2f",
                                        "background-color": "#ffcdd2",
                                        "border-radius": "50%"
                                      }
                                    },
                                    [_vm._v("")]
                                  ),
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(rootSuite.failures) +
                                      "\n                "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "li",
                                {
                                  staticStyle: {
                                    display: "inline",
                                    color: "#000000",
                                    flex: "0 0 25%"
                                  },
                                  attrs: { title: "Pending" }
                                },
                                [
                                  _c(
                                    "i",
                                    {
                                      staticClass: "material-icons",
                                      staticStyle: {
                                        position: "relative",
                                        top: "5px",
                                        color: "#616161",
                                        "background-color": "#f5f5f5",
                                        "border-radius": "50%"
                                      }
                                    },
                                    [_vm._v("")]
                                  ),
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(rootSuite.pending) +
                                      "\n                "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "li",
                                {
                                  staticStyle: {
                                    display: "inline",
                                    color: "#000000",
                                    flex: "0 0 25%"
                                  },
                                  attrs: { title: "Skipped" }
                                },
                                [
                                  _c(
                                    "i",
                                    {
                                      staticClass: "material-icons",
                                      staticStyle: {
                                        position: "relative",
                                        top: "5px",
                                        color: "#0288d1",
                                        "background-color": "#b3e5fc",
                                        "border-radius": "50%"
                                      }
                                    },
                                    [_vm._v("")]
                                  ),
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(rootSuite.skipped) +
                                      "\n                "
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-left": "0",
                            flex: "0 0 10%",
                            "padding-top": "10px"
                          }
                        },
                        [
                          _c(
                            "svg",
                            {
                              staticClass: "ct-chart-donut",
                              staticStyle: {
                                width: "50px",
                                height: "50px",
                                float: "right"
                              },
                              attrs: {
                                "xmlns:ct":
                                  "http://gionkunz.github.com/chartist-js/ct",
                                width: "100%",
                                height: "100%"
                              }
                            },
                            [
                              _c(
                                "g",
                                { staticClass: "ct-series ct-series-a" },
                                [
                                  rootSuite.resultToRender === 1
                                    ? _c("path", {
                                        staticClass:
                                          "suite--chart-slice---1EQ6h",
                                        staticStyle: {
                                          fill: "#f44336",
                                          stroke: "#fff",
                                          "stroke-width": "2px"
                                        },
                                        attrs: {
                                          d:
                                            "M25.004,50A25,25,0,1,0,25,50L25,41A16,16,0,1,1,25.003,41Z",
                                          "ct:value": "1"
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  rootSuite.resultToRender === 2
                                    ? _c("path", {
                                        staticClass:
                                          "suite--chart-slice---1EQ6h",
                                        staticStyle: {
                                          fill: "#f4e236",
                                          stroke: "#fff",
                                          "stroke-width": "2px"
                                        },
                                        attrs: {
                                          d:
                                            "M25.004,50A25,25,0,1,0,25,50L25,41A16,16,0,1,1,25.003,41Z",
                                          "ct:value": "1"
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  rootSuite.resultToRender === 0
                                    ? _c("path", {
                                        staticClass:
                                          "suite--chart-slice---1EQ6h",
                                        staticStyle: {
                                          fill: "#4caf50",
                                          stroke: "#fff",
                                          "stroke-width": "2px"
                                        },
                                        attrs: {
                                          d:
                                            "M25.004,50A25,25,0,1,0,25,50L25,41A16,16,0,1,1,25.003,41Z",
                                          "ct:value": "1"
                                        }
                                      })
                                    : _vm._e()
                                ]
                              ),
                              _vm._v(" "),
                              _c("g"),
                              _vm._v(" "),
                              _c("g"),
                              _vm._v(" "),
                              _c("g")
                            ]
                          )
                        ]
                      )
                    ])
                  ])
                ]
              )
            })
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "h5",
          {
            staticStyle: {
              "margin-left": "10px",
              "margin-top": "100px",
              "font-weight": "bolder"
            }
          },
          [_vm._v("Notices:")]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticStyle: { margin: "10px 10px 100px 10px" } },
          [
            _c("b-form-textarea", {
              attrs: {
                id: "textarea1",
                placeholder: "Enter something",
                rows: 10,
                "max-rows": 6,
                readonly: ""
              },
              model: {
                value: _vm.notificationData,
                callback: function($$v) {
                  _vm.notificationData = $$v
                },
                expression: "notificationData"
              }
            })
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9799f942", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9799f942","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/home-component.vue
// module id = null
// module chunks = 